import React from 'react'
import UiContentCard from "../../../components/cards/UiContentCard"
import London from "../../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../../styles/img/favourites/tokyo.jpg"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"


export default function TrendingAcrossSherbet(props) {
    const readMore = () => {
    }

    return (
        <>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Nike}
                    rating="4.41"
                    reviews="47"
                    heading="Nike"
                    footer="true"
                    bottomIcon="true"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    readMore={readMore}
                  
                />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={London}
                    rating="4.41"
                    reviews="47"
                    heading="London"
                    readMore={readMore}
                    bottomIcon="true"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                  
                    footer="true"
                />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Tokyo}
                    rating="4.41"
                    reviews="47"
                    heading="Tokyo"
                    readMore={readMore}
                    bottomIcon="true"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    footer="true"
                />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Nike}
                    rating="4.41"
                    reviews="47"
                    heading="Nike"
                    bottomIcon="true"
                    readMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    footer="true"
                />
            </UiCol>
          
        </>
    )
}
